module.exports = __webpack_public_path__ + "static/media/logo.816b0bc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.png
// module id = 498
// module chunks = 0